export const getWholesalerDisplayName = (type) => {
    switch (type) {
        case 'bluepax_secondary':
            return 'BluPax Pharma';
        case 'bloodworth_secondary':
            return 'Bloodworth Wholesale';
        case 'capital_secondary':
            return 'Capital Drug';
        case 'rx_supply_secondary':
            return 'Prescription Supply';
        case 'keysource_secondary':
            return 'KeySource USA';
        case 'toprx_secondary':
            return 'TopRx Pharma';
        case 'auburn_secondary':
            return 'Auburn Generics';
        case 'ipc_secondary':
            return 'IPC Warehouse';
        case 'mckesson_primary':
            return 'McKesson';
        case 'cardinal_primary':
            return 'Cardinal';
        case 'amerisource_primary':
            return 'AmerisourceBergen';
        case 'twosrx_secondary':
            return 'Second Source Rx';
        default:
            return 'N/A';
    }
};
export var PrimaryWholesalerName;
(function (PrimaryWholesalerName) {
    PrimaryWholesalerName["MCKESSON"] = "McKesson";
    PrimaryWholesalerName["CARDINAL_HEALTH"] = "Cardinal Health";
    PrimaryWholesalerName["AMERISOURCE"] = "Amerisource Bergen";
    PrimaryWholesalerName["SMITH_DRUG"] = "Smith Drug";
    PrimaryWholesalerName["LOUISIANA_WHOLESALE"] = "Louisiana Wholesale Drug";
    PrimaryWholesalerName["MUTUAL_DRUG"] = "Mutual Drug Company";
    PrimaryWholesalerName["MORRIS_DICKSON"] = "Morris Dickson";
    PrimaryWholesalerName["API"] = "API";
    PrimaryWholesalerName["OTHER"] = "Other";
})(PrimaryWholesalerName || (PrimaryWholesalerName = {}));
export var SecondaryWholesalerName;
(function (SecondaryWholesalerName) {
    SecondaryWholesalerName["BLUPAX"] = "Blupax";
    SecondaryWholesalerName["CAPITAL"] = "Capital";
    SecondaryWholesalerName["RXSUPPLY"] = "Prescription Supply";
    SecondaryWholesalerName["BLOODWORTH"] = "Bloodworth";
    SecondaryWholesalerName["KEYSOURCE"] = "Keysource";
    SecondaryWholesalerName["TOPRX"] = "TopRx";
    SecondaryWholesalerName["AUBURN"] = "Auburn";
    SecondaryWholesalerName["IPC"] = "IPC";
    SecondaryWholesalerName["TWOSRX"] = "Second Source";
})(SecondaryWholesalerName || (SecondaryWholesalerName = {}));
export const mapPrimaryNameToWholesaler = (primaryName) => {
    if (primaryName === PrimaryWholesalerName.MCKESSON) {
        return 'mckesson_primary';
    }
    if (primaryName === PrimaryWholesalerName.AMERISOURCE) {
        return 'amerisource_primary';
    }
    if (primaryName === PrimaryWholesalerName.CARDINAL_HEALTH) {
        return 'cardinal_primary';
    }
    return undefined;
};
export const mapWholesalerToPrimaryName = (wholesaler) => {
    switch (wholesaler) {
        case 'mckesson_primary':
            return PrimaryWholesalerName.MCKESSON;
        case 'amerisource_primary':
            return PrimaryWholesalerName.AMERISOURCE;
        case 'cardinal_primary':
            return PrimaryWholesalerName.CARDINAL_HEALTH;
        case 'bluepax_secondary':
            return SecondaryWholesalerName.BLUPAX;
        case 'capital_secondary':
            return SecondaryWholesalerName.CAPITAL;
        case 'rx_supply_secondary':
            return SecondaryWholesalerName.RXSUPPLY;
        case 'bloodworth_secondary':
            return SecondaryWholesalerName.BLOODWORTH;
        case 'keysource_secondary':
            return SecondaryWholesalerName.KEYSOURCE;
        case 'toprx_secondary':
            return SecondaryWholesalerName.TOPRX;
        case 'auburn_secondary':
            return SecondaryWholesalerName.AUBURN;
        case 'ipc_secondary':
            return SecondaryWholesalerName.IPC;
        case 'twosrx_secondary':
            return SecondaryWholesalerName.TWOSRX;
        default:
            return undefined;
    }
};
